import { useSuspenseQuery } from "@apollo/client";
import { format } from "date-fns";

import { MapEditorPlannerAreaPanelDocument } from "./queries.generated";

export function useSuspensePlannerAreaQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorPlannerAreaPanelDocument, {
        variables: {
            mapEditorFeatureId,
            onDate: format(new Date(), "yyyy-MM-dd"),
        },
    });
}
